import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../../global/config/app.config';
import { APP_CONFIG } from '../../global/config/config.token';
import { Router } from '@angular/router';
import { DonorDedupeVM } from '../models/SelectListItem';

@Injectable({
  providedIn: 'root'
})

export class DonorManualDedupesService {

  constructor(private httpClient: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig,
    private router: Router) { }

    GetDonorManualDedupes(params:{ campaignId: number, filter: number, currentDay: boolean}   ) {
      const url = `${this.config.apiUrl}DonorDedupe/donor-manual-dedupes`;
        return this.httpClient.get<DonorDedupeVM[]>(url, {params, withCredentials: true });
    };
}
